export enum ImportPlatform {
  GORGIAS = "gorgias",
  GORGIAS_NATIVE = "gorgias_native",
  ZENDESK = "zendesk",
  REAMAZE = "reamaze",
  RICHPANEL = "richpanel",
}

export enum ImportTab {
  MACROS = "macros",
  TAGS = "tags",
  FAQS = "faqs",
  VIEWS = "views",
  KNOWLEDGE = "knowledge",
  CONVERSATIONS = "conversations",
}

export interface ImportTabConfig {
  key: ImportTab;
  label: string;
  component: React.ComponentType<{ teamId: string | undefined }>;
}

export interface PlatformConfig {
  id: ImportPlatform;
  displayName: string;
  tabs: ImportTabConfig[];
}
